<template>
        <v-row class="mt-md-n15 mb-10 px-md-10">
            <v-col v-for="(channel,index) in channels" :key="index" sm="6" md="6" lg="3">
                <v-card @click="goToChannel(channel.id)">
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-text class="font-weight-bold">{{ channel.name }}</v-card-text>
                            <v-card-text class="pt-0 pr-0">{{ channel.intro }}</v-card-text>
                        </div>    
                        <v-avatar class="ma-3" size="100" tile>
                            <v-img :src="processOtherImage(channel.icon_url)"></v-img>
                        </v-avatar> 
                    </div>
                </v-card>
            </v-col>
        </v-row>
</template>

<script>
import { processOtherImage } from '../../utils/product';

export default {
    props: ['channels'],
    methods: {
        processOtherImage,
        goToChannel(id) {
            this.$router.push({ path: '/mall', query: {ch:id}})
        }
    }
}
</script>